const personsaccount = {
	name: '',
	icon: '',
	fields: {
		hp_id: 'ID',
		lastname: 'Person',
		tos: 'Terms of Service',
		privacy: 'Privacy Policy',
		user: {
			email: 'Email',
			logins_count: 'Logins',
			last_login: {
				created_at: 'Last Login',
			},
		},
		created_at: 'Created',
	},
}

export default personsaccount
